const LeadModalFormBodyBlock = () => {
  return <>TODO migrate block modal here</>;
};

export default LeadModalFormBodyBlock;
